/**
 * Convert Int32 to bigint
 *
 * @param {import('./Int32Type.js').BrandedInt32} value - Int32 value
 * @returns {bigint} BigInt value
 */
export function toBigInt(value) {
	return BigInt(value);
}
